export default "__VITE_ASSET__BVFlkFxf__"